/* ==========================================================================
   Shopp Games - ajustes de DOM da pagina de produto

   1. Reorganiza o bloco que o tema monta em gerarParcelas(): a linha do Pix
      vai para dentro do card de preco e o parcelamento desce para baixo dos
      botoes.

   2. Corrige comportamento herdado: o tema tenta refazer esse bloco na troca
      de variante ouvindo 'variant-radios label', seletor que nao existe nesta
      versao (a pagina usa <variant-selects>), entao o bloco sumia e nao
      voltava. Quando ele desaparece, gerarParcelas() e chamada de novo.

   3. Exige a escolha da variante: em produto com duas ou mais opcoes, nenhuma
      vem marcada e a compra so libera depois do clique. Enquanto isso o card
      ja aparece completo, com os valores do menor preco.
   ========================================================================== */
(function () {
  'use strict';

  var POLL_INTERVAL = 250;
  var POLL_DURATION = 20000;
  var REGENERATE_COOLDOWN = 1500;
  var FREEZE_DURATION = 3000;

  var LABEL_BUY = 'COMPRAR AGORA';
  var LABEL_CHOOSE = 'ESCOLHA UMA OPÇÃO';

  var ICON_PIX =
    '<svg class="sg-pix__icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">' +
    '<path d="M5.283 18.36c.951 0 1.844-.371 2.517-1.043l3.643-3.643a.494.494 0 0 1 .674-.001l3.658 3.658a3.532 ' +
    '3.532 0 0 0 2.516 1.041h.718l-4.62 4.617a3.687 3.687 0 0 1-5.21 0L4.55 18.36ZM18.29 5.638c-.95 0-1.843.372' +
    '-2.516 1.043l-3.658 3.658a.477.477 0 0 1-.674 0L7.8 6.686A3.532 3.532 0 0 0 5.282 5.64h-.732l4.63-4.626a3.' +
    '686 3.686 0 0 1 5.21 0l4.616 4.624ZM3.807 6.375h1.476c.656 0 1.3.266 1.763.73l3.643 3.643a1.222 1.222 0 0 ' +
    '0 1.727 0l3.658-3.658a2.5 2.5 0 0 1 1.762-.73h1.906l2.788 2.79a3.686 3.686 0 0 1 0 5.21l-2.788 2.79h-1.906' +
    'a2.5 2.5 0 0 1-1.762-.73l-3.657-3.658a1.257 1.257 0 0 0-1.728 0l-3.643 3.644a2.5 2.5 0 0 1-1.763.73H3.807l' +
    '-2.79-2.79a3.686 3.686 0 0 1 0-5.21Z"/></svg>';

  var ICON_CARD =
    '<svg class="sg-payments__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
    '<rect x="2" y="5" width="20" height="14" rx="2.5"/><path d="M2 10h20"/><path d="M6 15h4"/></svg>';

  var ICON_CART =
    '<span class="sg-cart-icon" aria-hidden="true">' +
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" ' +
    'stroke-linejoin="round" focusable="false"><circle cx="9.5" cy="20" r="1.5"/><circle cx="18" cy="20" r="1.5"/>' +
    '<path d="M2.5 3.5h2.3l2.5 11.2a1.6 1.6 0 0 0 1.6 1.3h8.7a1.6 1.6 0 0 0 1.6-1.3L21 7.5H6.2"/></svg></span>';

  function parseMoney(text) {
    if (!text) return null;
    var digits = String(text).replace(/[^\d.,]/g, '');
    if (!digits) return null;
    var sep = Math.max(digits.lastIndexOf(','), digits.lastIndexOf('.'));
    var value;
    if (sep > -1 && digits.length - sep - 1 === 2) {
      value = digits.slice(0, sep).replace(/[.,]/g, '') + '.' + digits.slice(sep + 1);
    } else {
      value = digits.replace(/[.,]/g, '');
    }
    var parsed = parseFloat(value);
    return isNaN(parsed) ? null : parsed;
  }

  function formatBRL(value) {
    var parts = value.toFixed(2).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return 'R$ ' + whole + ',' + parts[1];
  }

  function reformat(text) {
    var value = parseMoney(text);
    return value === null ? String(text || '').trim() : formatBRL(value);
  }

  function normalizeMoneyText(root) {
    if (!root || root.dataset.sgMoney === '1') return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    for (var i = 0; i < nodes.length; i++) {
      var text = nodes[i].nodeValue;
      if (text.indexOf('R$') === -1) continue;
      var updated = text.replace(/R\$\s*\d[\d.,]*/g, function (match) {
        var value = parseMoney(match);
        return value === null ? match : formatBRL(value);
      });
      if (updated !== text) nodes[i].nodeValue = updated;
    }
    root.dataset.sgMoney = '1';
  }

  function textOf(root, selector) {
    var el = root.querySelector(selector);
    return el ? el.textContent.trim() : '';
  }

  function isVisible(el) {
    return !!el && el.offsetParent !== null;
  }

  var productData = null;
  function getProductData() {
    if (productData !== null) return productData;
    var el = document.getElementById('sg-product-data');
    if (!el) return (productData = false);
    try {
      productData = JSON.parse(el.textContent);
    } catch (error) {
      productData = false;
    }
    return productData;
  }

  function findBuyButton(container) {
    var candidates = container.querySelectorAll('.shopify-payment-button__button--unbranded');
    for (var i = 0; i < candidates.length; i++) {
      if (isVisible(candidates[i])) return candidates[i];
    }
    return null;
  }

  function priceCard(container) {
    return container.querySelector('[id^="price-template"]');
  }

  /* Altura do card durante a troca de variante -----------------------------
     O tema apaga o bloco de formas de pagamento e o recria no formato dele,
     e so entao este arquivo o reorganiza. Sem tratamento o card faz
     177 -> 101 -> 193 -> 177, parecendo que a pagina se remonta. O CSS esconde
     o bloco enquanto ele nao esta reorganizado e a altura fica presa aqui.
     O prazo existe porque enhance() roda logo apos o clique, antes de o tema
     comecar a trocar - sem ele, a altura seria liberada na mesma hora. */
  var freezeUntil = 0;

  function freezeCardHeight(container) {
    var card = priceCard(container);
    if (!card) return;
    var height = Math.round(card.getBoundingClientRect().height);
    if (height > 0) {
      card.dataset.sgHeight = String(height);
      card.style.minHeight = height + 'px';
      freezeUntil = Date.now() + FREEZE_DURATION;
    }
  }

  function holdCardHeight(container) {
    var card = priceCard(container);
    if (!card) return;
    var block = container.querySelector('#formas-pagamento');
    var ready = block && block.dataset.sgDone === '1';
    if (ready && Date.now() > freezeUntil) {
      card.style.minHeight = '';
      var height = Math.round(card.getBoundingClientRect().height);
      if (height > 0) card.dataset.sgHeight = String(height);
    } else if (!ready && card.dataset.sgHeight) {
      card.style.minHeight = card.dataset.sgHeight + 'px';
    }
  }

  function markComparePrice(container) {
    var strikes = container.querySelectorAll('.price__sale > span > s.price-item--regular');
    for (var i = 0; i < strikes.length; i++) {
      strikes[i].parentElement.classList.add('sg-compare');
    }
  }

  var lastRegenerate = 0;

  function ensureThemeBlock(container) {
    if (container.querySelector('#formas-pagamento')) return;
    var stale = container.querySelector('.sg-payments');
    if (stale) stale.remove();
    var now = Date.now();
    if (now - lastRegenerate < REGENERATE_COOLDOWN) return;
    if (typeof window.gerarParcelas !== 'function') return;
    lastRegenerate = now;
    try {
      window.gerarParcelas();
    } catch (error) {
      /* Se a funcao do tema falhar, a pagina segue sem o bloco. */
    }
  }

  function rebuildPayments(container) {
    var block = container.querySelector('#formas-pagamento');
    if (!block || block.dataset.sgDone === '1') return;

    var emAte = block.querySelector('.em-ate');
    if (!emAte) return;

    var pixValue = textOf(emAte, 'h5');
    if (!pixValue) return;

    var rawText = emAte.textContent.replace(/\s+/g, ' ');
    var percentMatch = rawText.match(/(\d+(?:[.,]\d+)?)\s*%/);
    var percent = percentMatch ? percentMatch[1].replace('.', ',') : '5';

    var total = parseMoney(textOf(emAte, '#valor_final'));
    var pix = parseMoney(pixValue);
    var installments = textOf(emAte, '#parcelas_final');
    var installmentValue = textOf(emAte, '#menor_parcela');

    var pixRow = document.createElement('div');
    pixRow.className = 'sg-pix';
    pixRow.innerHTML =
      ICON_PIX +
      '<span class="sg-pix__label">PIX</span>' +
      '<span class="sg-pix__value">' +
      reformat(pixValue) +
      '</span>' +
      '<span class="sg-pix__badge">' +
      percent +
      '% OFF</span>';

    emAte.textContent = '';
    emAte.appendChild(pixRow);

    if (total !== null && pix !== null && total > pix) {
      var save = document.createElement('p');
      save.className = 'sg-pix__save';
      save.textContent = 'Economize ' + formatBRL(total - pix) + ' pagando no Pix';
      emAte.appendChild(save);
    }

    var buttonsWrap = null;
    var children = container.children;
    for (var i = 0; i < children.length; i++) {
      if (children[i].querySelector('product-form, .product-form__buttons')) {
        buttonsWrap = children[i];
        break;
      }
    }

    var previous = container.querySelector('.sg-payments');
    if (previous) previous.remove();

    if (buttonsWrap && installments && installmentValue) {
      var payments = document.createElement('div');
      payments.className = 'sg-payments';
      var row = document.createElement('div');
      row.className = 'sg-payments__row';
      row.innerHTML =
        ICON_CARD + '<span>' + installments + ' de ' + reformat(installmentValue) + ' sem juros</span>';
      payments.appendChild(row);
      var toggle = block.querySelector('#mais-formas-pagamento');
      var list = block.querySelector('.formas-pagamento');
      if (toggle) payments.appendChild(toggle);
      if (list) {
        normalizeMoneyText(list);
        payments.appendChild(list);
      }
      buttonsWrap.insertAdjacentElement('afterend', payments);
    }

    block.dataset.sgDone = '1';
  }

  function applyCartIcon(container) {
    var submit = container.querySelector('.product-form__submit');
    if (!submit || submit.dataset.sgDone === '1') return;
    submit.insertAdjacentHTML('afterbegin', ICON_CART);
    submit.dataset.sgDone = '1';
  }

  function markBuyMode(container) {
    var buttons = container.querySelector('.product-form__buttons');
    if (!buttons) return;
    if (!window.__sgSettled) return;
    if (findBuyButton(container)) {
      buttons.classList.remove('sg-no-buy');
    } else {
      buttons.classList.add('sg-no-buy');
    }
  }

  /* --- Escolha obrigatoria da variante ------------------------------------ */

  function variantInputs(container) {
    return container.querySelectorAll('.product-form__input--pill input[type="radio"]');
  }

  function ensureFromPrice(container) {
    var card = priceCard(container);
    if (!card || card.querySelector('.sg-from')) return;
    var data = getProductData();
    if (!data || !data.priceMinFormatted) return;
    var el = document.createElement('div');
    el.className = 'sg-from';
    el.innerHTML = '<span class="sg-from__label">A partir de</span><span class="sg-from__value"></span>';
    el.querySelector('.sg-from__value').textContent = data.priceMinFormatted;
    card.insertBefore(el, card.firstChild);
  }

  /* Antes da escolha o card mostra os numeros do menor preco. A conta segue a
     mesma ordem de operacoes do tema (preco - taxa * preco): inverter isso
     muda o centavo final e o valor pularia ao escolher a variante. */
  function applyProvisionalPrices(container) {
    var data = getProductData();
    if (!data || !data.priceMin) return;

    var min = data.priceMin / 100;

    var badge = container.querySelector('.sg-pix__badge');
    var percentMatch = badge ? badge.textContent.match(/(\d+)/) : null;
    var percent = percentMatch ? parseInt(percentMatch[1], 10) : 5;

    var pixValue = Math.round((min - (percent / 100) * min) * 100) / 100;
    var saved = Math.round((min - pixValue) * 100) / 100;

    var value = container.querySelector('.sg-pix__value');
    if (value) value.textContent = formatBRL(pixValue);

    var save = container.querySelector('.sg-pix__save');
    if (save) save.textContent = 'Economize ' + formatBRL(saved) + ' pagando no Pix';

    var row = container.querySelector('.sg-payments__row span');
    if (row) {
      var parcelsMatch = row.textContent.match(/(\d+)\s*x/);
      var parcels = parcelsMatch ? parseInt(parcelsMatch[1], 10) : 3;
      row.textContent = parcels + 'x de ' + formatBRL(min / parcels) + ' sem juros';
    }
  }

  function setBuyLabel(button, label) {
    if (!button || button.dataset.sgLabel === label) return;
    button.textContent = label;
    button.dataset.sgLabel = label;
  }

  function applyChoiceGate(container) {
    var locked = variantInputs(container).length > 1 && !window.__sgVariantChosen;

    container.classList.toggle('sg-awaiting-choice', locked);

    if (locked) {
      ensureFromPrice(container);
      applyProvisionalPrices(container);
      var inputs = variantInputs(container);
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].checked) inputs[i].checked = false;
      }
    }

    var submit = container.querySelector('.product-form__submit');
    if (submit) {
      submit.disabled = locked;
      submit.setAttribute('aria-disabled', locked ? 'true' : 'false');
    }

    var buy = findBuyButton(container);
    if (buy) {
      buy.disabled = locked;
      buy.setAttribute('aria-disabled', locked ? 'true' : 'false');
      setBuyLabel(buy, locked ? LABEL_CHOOSE : LABEL_BUY);
    }
  }

  /* O clique congela a altura do card antes de o tema comecar a re-renderizar */
  function watchVariantChoice() {
    document.addEventListener(
      'change',
      function (event) {
        var target = event.target;
        if (!target || target.type !== 'radio') return;
        if (!target.closest('.product-form__input--pill')) return;
        window.__sgVariantChosen = true;
        var containers = document.querySelectorAll('.product__info-container');
        for (var i = 0; i < containers.length; i++) freezeCardHeight(containers[i]);
        enhance();
      },
      true
    );
  }

  function enhance() {
    var containers = document.querySelectorAll('.product__info-container');
    for (var i = 0; i < containers.length; i++) {
      markComparePrice(containers[i]);
      ensureThemeBlock(containers[i]);
      rebuildPayments(containers[i]);
      applyCartIcon(containers[i]);
      markBuyMode(containers[i]);
      applyChoiceGate(containers[i]);
      holdCardHeight(containers[i]);
    }
  }

  var scheduled = false;

  /* setTimeout, nao requestAnimationFrame: em aba de segundo plano o rAF nao
     roda, a flag ficaria presa em true e o ajuste pararia de acontecer. */
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.setTimeout(function () {
      scheduled = false;
      enhance();
    }, 50);
  }

  function start() {
    if (!document.querySelector('.product__info-container')) return;

    watchVariantChoice();
    enhance();

    var elapsed = 0;
    var timer = window.setInterval(function () {
      elapsed += POLL_INTERVAL;
      enhance();
      if (elapsed >= POLL_DURATION) window.clearInterval(timer);
    }, POLL_INTERVAL);

    window.__sgProductObserver = new MutationObserver(schedule);
    window.__sgProductObserver.observe(document.body, { childList: true, subtree: true });

    window.addEventListener('load', function () {
      window.setTimeout(function () {
        window.__sgSettled = true;
        enhance();
      }, 1500);
    });

    document.addEventListener('shopify:section:load', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
